import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Auth0Provider } from '@auth0/auth0-react'
import './index.css'
import App from './App.jsx'
import AuthGuard from './AuthGuard.jsx'
import { getAuth0Config } from './auth0Config.js'

// After the Auth0 redirect, send the user back to where they started
// (defaults to the app root) and drop the ?code&state query + /login-sso path.
const onRedirectCallback = (appState) =>
  window.history.replaceState({}, document.title, appState?.target || '/')

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Auth0Provider {...getAuth0Config()} onRedirectCallback={onRedirectCallback}>
      <AuthGuard>
        <App />
      </AuthGuard>
    </Auth0Provider>
  </StrictMode>,
)
